module.exports = __webpack_public_path__ + "static/media/review-1.1c2c3d03.png";